<template>
	<rb-thumbnail
		class="rb-series-thumbnail"
		:image-url="series.getHeroUrl()"
		v-bind="$attrs"
		v-on="$listeners"
		:to="series.getRoute()"
	>
		<div slot="center">
			<img class="series-logo" :src="series.getLogoUrl()" alt="">
		</div>
	</rb-thumbnail>
</template>

<script>
	import RbThumbnail from './RbThumbnail';
	import {Series} from '../../../shared/entities/Series';

	export default {
		name: 'RbSeriesThumbnail',
		components: {RbThumbnail},
		props: {
			series: {
				type: Series,
				required: true
			}
		},
		data: () => ({}),
	}
</script>

<style lang="scss" scoped>
	.rb-series-thumbnail {
		.series-logo {
			width: 75%;
		}
		/deep/ > img {
			opacity: .5;
		}
	}
</style>
